import { WhatsappApiContext } from './WhatsappApi.context.ts';
import { tWhatsappApiProviderProps } from './WhatsappApi.types.ts';
import useWhatsappApi from './WhatsappApi.hook.ts';

export default function WhatsappApiProvider(props: tWhatsappApiProviderProps) {
  const { children } = props;
  const value = useWhatsappApi();

  return (
    <WhatsappApiContext.Provider value={value}>
      {children}
    </WhatsappApiContext.Provider>
  );
}
